import styled from 'styled-components';
import { InfoTitle } from 'components/Toolkit/InfoTitle/InfoTitle';
import { MetaListItem } from 'components/Toolkit/InfoTitle/MetaListItem/MetaListItem';

import { media } from 'helpers/breakpoints';

export interface TestimonialProps {
  icon: string;
  name: string;
  description?: string;
  testimonial?: string;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;

  background-color: ${({ theme }) => theme.colors.WHITE};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  padding: ${({ theme }) => theme.spacing.M16};
  max-width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing.M16};

  ${media.large} {
    margin-bottom: ${({ theme }) => theme.spacing.M24};
    padding: ${({ theme }) => theme.spacing.M24};
  }
`;

const SInfoTitle = styled(InfoTitle)<{ testimonial?: boolean }>`
  margin-bottom: ${({ theme, testimonial }) =>
    testimonial ? theme.spacing.S8 : ''};

  ${MetaListItem} {
    max-width: 250px;

    ${media.medium} {
      max-width: 100%;
    }
  }
`;

const TestimonialContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.GREY_LIGHTER};
  border-radius: ${({ theme }) => theme.borderRadius.default};
`;

const TestimonialSection = styled.p`
  ${({ theme }) => theme.fontSize.M16};

  padding: ${({ theme }) => theme.spacing.M16};
`;

function Testimonial({
  icon,
  name,
  description,
  testimonial,
}: TestimonialProps) {
  return (
    <Container>
      <SInfoTitle
        title={name}
        listItems={description ? [description] : []}
        illustration={icon}
        testimonial={Boolean(testimonial)}
      />
      {testimonial && (
        <TestimonialContainer>
          <TestimonialSection>{testimonial}</TestimonialSection>
        </TestimonialContainer>
      )}
    </Container>
  );
}

export { Testimonial };
